import { SearchOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Button, Form, Input, Space } from 'antd';
import React from 'react';

import { PREFIX } from '@app/constants';
import type { TableHeaderTypeProps } from '@app/pages/SalesFunnels/types';

import type { FC } from 'react';
import '@pages/SalesFunnels/SalesFunnelsRegistry/styles/TableHeader.desktop.scss';
import '@pages/SalesFunnels/SalesFunnelsRegistry/styles/TableHeader.tablet.scss';
import '@pages/SalesFunnels/SalesFunnelsRegistry/styles/TableHeader.mobile.scss';

export const TableHeader: FC<TableHeaderTypeProps> = ({
  handleResetForm,
  handleSearch,
  headerForm,
}) => (
  <div className={`${PREFIX}sales-funnels-table-header`}>
    <Form form={headerForm} className="form" onFinish={handleSearch}>
      <Form.Item className="search-field" name="SearchField">
        <Input
          placeholder="Введите часть названия или описания воронки"
          addonBefore={<SearchOutlined />}
          className="input"
        />
      </Form.Item>

      <Space className="button-space">
        <Button
          className="button"
          icon={<CloseCircleOutlined />}
          onClick={handleResetForm}
        >
          Сброс
        </Button>
        <Button className="button" type="primary" htmlType="submit">
          Показать
        </Button>
      </Space>
    </Form>
  </div>
);
